<template>
    <div
        class="px-4 pb-4"
        style="padding-top: 90px"
    >
        <user-events-list :user-id="user.id" />
    </div>
</template>

<script>
import UserEventsList from "../office/admin/users/UserEventsList.vue";
import AuthService from "../../services/AuthService";
export default {
    components: {
        UserEventsList,
    },
    computed: {
        user() {
            return AuthService.user;
        }
    },
}
</script>

<style scoped lang="scss">

</style>


// WEBPACK FOOTER //
// resources/assets/js/components/engineer/CalendarList.vue